import {Component, Input, OnInit} from '@angular/core';
import {DamItem, DamItemHistory, PageApiResponse} from 'compob2b-libs';
import {CrudConfig} from '../../../../../../admin-shared/interfaces/crud.config';
import {ListComponent} from '../../../../../../admin-shared/crud-components/list/list.component';
import {DAM_ITEM_HISTORY_FORM} from './dam-history-forms.config';
import {Observable} from "rxjs";

enum DamChangeType {
  CHANGE_ATTRIBUTE = 'CHANGE_ATTRIBUTE',
  CHANGE_FEATURES = 'CHANGE_FEATURES',
  CHANGE_ROLE_PERMISSIONS = 'CHANGE_ROLE_PERMISSIONS',
  CHANGE_CATALOG = 'CHANGE_CATALOG',
}

const damChangeTypeLabels: Record<DamChangeType, string> = {
  [DamChangeType.CHANGE_ATTRIBUTE]: 'Изменение параметра',
  [DamChangeType.CHANGE_FEATURES]: 'Изменение характеристики',
  [DamChangeType.CHANGE_ROLE_PERMISSIONS]: 'Изменение доступов',
  [DamChangeType.CHANGE_CATALOG]: 'Изменение каталога',
};

@Component({
    selector: 'app-file-change-history',
    templateUrl: './file-change-history.component.html',
    standalone: false
})
export class FileChangeHistoryComponent extends ListComponent<DamItemHistory> implements OnInit {

  @Input() model: DamItem;

  public config: CrudConfig = {
    uri: '/change-log/dam_item',
    columns: DAM_ITEM_HISTORY_FORM,
    defaultSortColumn: 'header',
    defaultSortDirection: 'asc',
    uriCreate: null,
    uriView: null,
    title: 'История изменений',
  };

  ngOnInit(): void {
    super.setConfig(this.config);
    super.ngOnInit();

    this.uri += '/' + this.model.id;
  }

  protected filterData(): Observable<DamItemHistory[]> {
    if (this.params.get('changeType')) {
      const searchValue = this.params.get('changeType').toLowerCase();
      const foundType = Object.values(DamChangeType).find(type =>
        type.toLowerCase().includes(searchValue) ||
        damChangeTypeLabels[type].toLowerCase().includes(searchValue)
      );

      if (foundType) {
        this.params = this.params.set('changeType', foundType);
      }
    }

    return super.filterData();
  }

  handleResponse(page: PageApiResponse<unknown>) {

    if (page.content) {
      (page.content as Array<DamItemHistory>).map((item: DamItemHistory) => {
        item.changeType = damChangeTypeLabels[item.changeType as DamChangeType] || item.changeType;

        return item;
      });
    }

    super.handleResponse(page);
  }

}
